/**
 * generate facebook share link
 * @param  {string} [url='']  what to share
 * @return {string}           share link
 */
export default function facebookShare(url = '') {
  return `http://facebook.com/sharer.php?u=${encodeURIComponent(url)}`;
}



// WEBPACK FOOTER //
// ./app/services/share/facebook.js